<template lang="pug">
    .container
        .title-container
            .title-group
                p.step 
                    strong STEP 03: 
                    | Summary of your order
                h3 Checkout

        .highlight-box(v-if="getConferenceDetails")
            h4 {{ getConferenceDetails.event_name }}

            .bottom-info
                .icon-info
                    img(src="@/assets/images/icons/calendar.svg")
                    p
                        span Date:
                        | {{ getConferenceDetails.start_date | formatDate }} - {{ getConferenceDetails.end_date | formatDate }}

                .icon-info
                    img(src="@/assets/images/icons/user.svg")
                    p
                        span Participants:
                        | {{ getConferenceDetails.no_of_public_participants_allowed }}
        .table-container
            table.checkout-tbl
                tr.tbl-head
                    td.tbl-column
                    td.tbl-column
                        h4 Description
                    td.tbl-column.right-column
                        h4 Unit Price({{ currency }})
                    td.tbl-column.right-column
                        h4 Qty
                    td.tbl-column.right-column
                        h4 Total({{ currency }})

                tbody.tbl-body
                    tr.tbl-row
                        td.tbl-column
                            h4 Resource
                        td.tbl-column 
                            .category.td-content
                                h4 {{ getConferenceDetails.center.hall_name }}
                                p From {{ getConferenceDetails.start_date | formatDate }} to {{ getConferenceDetails.end_date | formatDate }}

                        td.tbl-column
                            .td-content
                                p {{ currency }} {{ getConferenceDetails.center.price_per_day | convertTo(currency, lkr) | twoDecimal | decimalSeparator }}

                        td.tbl-column
                            .td-content
                                p {{ selectedDays }} days

                        td.tbl-column
                            .td-content
                                p {{ currency }} {{ hallTotal | convertTo(currency, lkr) | twoDecimal | decimalSeparator }}


        .total-grid
            .total-row
                .title Sub Total
                p {{ currency }} {{ subTotal | convertTo(currency, lkr) | twoDecimal | decimalSeparator }}

            .total-row
                .title NBT({{ nbt }}%)
                p {{ nbtAmount | convertTo(currency, lkr) | twoDecimal | decimalSeparator }}                

            .total-row
                .title VAT({{ vat }}%)
                p {{ vatAmount | convertTo(currency, lkr) | twoDecimal | decimalSeparator }}

            .total-row.net-total 
                .title Net Total
                p {{ currency }} {{ netTotal | convertTo(currency, lkr) | twoDecimal | decimalSeparator }}


        .button-row
            a.back(href="") 
                i.fa.fa-angle-left
                | Back

            router-link(to="/event-result").next.active Pay    
</template>

<script>

    import Vue from 'vue';
    import moment from 'moment';
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'NewCheckout',
        data() {
            return {
                checkoutData: [],
                subTotal: 0,
                vat: 0,
                nbt: 0,
                vatAmount: 0,
                nbtAmount: 0,
                netTotal: 0,
                hallTotal: 0,
                selectedDays: null,
                currency: 'USD',
                lkr: 0,               
            }
        },
        computed: {
            ...mapGetters(['getConferenceDetails', 'taxDetails', 'getCurrency', 'currencyDetails']),
        },
        methods: {
            ...mapActions(['getConference', 'getTax', 'getRates']),
            ...Vue.filter('convertTo', function(value, selected_currency, lkr) {
                if(value && selected_currency) {
                    if(selected_currency == 'LKR') {
                        return value * lkr;                       
                    } else {
                        return value;
                    }
                }
            }),
            ...Vue.filter('twoDecimal', function(value) {
                if(value) {
                    return Math.round(parseFloat(value) * 100) / 100;
                } else {
                    return 0;
                }
            }),
            ...Vue.filter('decimalSeparator', function(value) {
                if(value) {
                    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
            }),                        
            updateFee() {
                this.currency = 'USD';
            },
            onCurrencyUpdate() {
                if(this.getCurrency == 'LKR') {
                    this.getRates().then(() => {

                        this.currency = this.getCurrency;

                    });
                } else {
                   this.updateFee() 
                }
            },            
        },
        created() {
            this.getTax().then(() => {
                this.vat = this.taxDetails.vat;
                this.nbt = this.taxDetails.nbt;
            });
            this.getRates().then(() => {
                this.lkr = this.currencyDetails.lkr;
            });
        },        
        mounted() {
            this.onCurrencyUpdate(),
            this.getConference(window.localStorage.getItem('newEventSlug')).then(() => {
                this.checkoutData = this.getConferenceDetails;

                var start_date = moment(String(this.getConferenceDetails.start_date), 'YYYY-MM-DD');
                var end_date = moment(String(this.getConferenceDetails.end_date), 'YYYY-MM-DD');
                var diff = end_date.diff(start_date, 'days') + 1;

                this.selectedDays = diff;
                
                this.hallTotal = parseInt(diff) * parseFloat(this.getConferenceDetails.center.price_per_day);

                this.subTotal += this.hallTotal; 
                
                this.nbtAmount = (this.subTotal * this.nbt) / 100;
                this.nbtAmount = Math.round(parseFloat(this.nbtAmount) * 100) / 100;
                this.vatAmount = (parseFloat(this.subTotal) + this.nbtAmount) * this.vat/100;
                this.vatAmount = Math.round(parseFloat(this.vatAmount) * 100) / 100;
                this.netTotal = this.subTotal + this.nbtAmount + this.vatAmount;
                this.netTotal = Math.round(parseFloat(this.netTotal) * 100) / 100;
                                
            });

            Vue.filter('formatDate', function(value) {
                if(value) {
                    return moment(String(value)).format('DD MMM YYYY')
                }
            });
        },
        watch: {
            getCurrency: {
                handler: function() {
                    this.onCurrencyUpdate();
                }
            }
        }        
    }
</script>

<style lang="sass" scoped >
    @import "@/assets/css/2-base/_variables.sass"
    @import "@/assets/css/2-base/_placeholder.sass"    
    @import "@/assets/css/3-components/_checkout.sass"

    .highlight-box
        margin-bottom: 0
</style>


